/**
 * God bless StackOverflow
 */

/**
 *
 * @param xml
 * @returns {{}}
 */

export function soapResponseToJson(xml) {
	var json = xmlToJson(xml).Envelope.Body;

	return jsonize(json);
}

/**
 * Converts item.text = value to item = value
 * @param json
 */
function jsonize(json) {
	let jsonLength = Object.keys(json).length;
	if (jsonLength > 0) {
		for (var key in json) {
			if (json.hasOwnProperty(key)) {
				if (Object.keys(json[key]).length == 1 && typeof json[key]['text'] !== 'undefined') {
					json[key] = json[key]['text'];
				} else {
					json[key] = jsonize(json[key]);
				}
			}
		}
	}

	return json;
}

// Changes XML to JSON
function xmlToJson(xml) {

	// Create the return object
	var obj = {};

	if (xml.nodeType == 3) {// text
		obj = xml.nodeValue;
	}

	// do children
	if (xml.hasChildNodes()) {
		for (var i = 0; i < xml.childNodes.length; i++) {
			var item = xml.childNodes.item(i);
			var nodeName = item.nodeName.substring(item.nodeName.indexOf(":") + 1).replace('#', '');
			if (typeof (obj[nodeName]) == "undefined") {
				obj[nodeName] = xmlToJson(item);
			} else {
				if (typeof (obj[nodeName].push) == "undefined") {
					var old = obj[nodeName];
					obj[nodeName] = [];
					obj[nodeName].push(old);
				}
				obj[nodeName].push(xmlToJson(item));
			}
		}
	}

	if (Object.keys(obj).length == 0) {
		return '';
	} else {
		return obj;
	}
}



// WEBPACK FOOTER //
// build/services/soapService/xml2json.js